import { getTimeTillEndOfDayMs } from '@helpers';
import { FetchQueryOptions } from '@tanstack/react-query';
import { getEntityValues } from '@terminal/services/get-entity-values/getEntityValues';
import { queryClient } from '@terminal/services/query-client/queryClient';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { mapEntityValues } from '@terminal/stores/use-watchlist/mapEntityValues';
import { WatchlistEntities } from '@terminal/stores/use-watchlist/watchlist-types';

export const WATCHLIST_ENTITY_QUERY_KEY = 'watchlist_entity';

export const fetchWatchlistEntityQuery = (tag: string) => {
  const isApiScreenerEntitiesV3FlagEnabled = useFlags
    .getState()
    .getFeatureFlagState('DATA-1243-api_screener_entities_v3');
  const isApiEntityLatestValuesV2FlagEnabled = useFlags
    .getState()
    .getFeatureFlagState('DATA-1276-api_entity_latest_values_v2');

  return queryClient.fetchQuery(
    createQueryOptions(tag, {
      isApiScreenerEntitiesV3FlagEnabled,
      isApiEntityLatestValuesV2FlagEnabled,
    })
  );
};

export const createQueryOptions = (
  tag: string,
  flags: {
    isApiScreenerEntitiesV3FlagEnabled: boolean;
    isApiEntityLatestValuesV2FlagEnabled: boolean;
  }
): FetchQueryOptions<WatchlistEntities | null> => ({
  queryKey: [
    WATCHLIST_ENTITY_QUERY_KEY,
    tag,
    flags.isApiScreenerEntitiesV3FlagEnabled,
    flags.isApiEntityLatestValuesV2FlagEnabled,
  ],
  queryFn: async () => {
    const res = await getEntityValues(tag, flags);

    if (!res) {
      return null;
    }

    if (!res.snakeMeta) {
      return null;
    }

    const mapped = mapEntityValues({
      entities: [{ tag }],
      ...res,
      tag,
    });

    return mapped[0];
  },
  staleTime: getTimeTillEndOfDayMs(),
});
